import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Docs.css';
import history from './History';
import DocsTocMain from './DocsTocMain';
import DocsTocMinor from './DocsTocMinor';
import QuickStart from './QuickStart';
import UserManual from './UserManual';
import EPLReference from './EPLReference';
import { useParams } from "react-router-dom";

export default function Docs(props) {
  const { reason } = useParams();
  return <DocsForReason {...props} reason={reason} />;
}

export class DocsForReason extends Component {
  constructor(props) {
    super(props);
    this.state = { docInFocus: "usermanual" };
    this.setDocInFocus = this.setDocInFocus.bind(this);
  }

  setDocInFocus(doc, e)  {
    e.preventDefault();
    this.setState({ docInFocus: doc});
  }

  render() {
    if (!this.props.isLoggedIn) {
      history.push('/login/' + this.props.reason, { from: history.location.pathname })
    }

    let renderContent;
    if (this.state.docInFocus === 'quickstart') {
      renderContent = <QuickStart className="docs-content"/>;
    } else if (this.state.docInFocus === 'usermanual') {
      renderContent = <UserManual className="docs-content" setDocInFocus={this.setDocInFocus}/>;
    } else if (this.state.docInFocus === 'eplreference') {
      renderContent = <EPLReference className="docs-content"/>;
    }

    return (
      <div>
        <Container fluid>
          <Row>
            <Col xs={2} className="docs-toc-main"><DocsTocMain setDocInFocus={this.setDocInFocus} docInFocus={this.state.docInFocus}/></Col>
            <Col xs={7} className="docs-contenct">
              {renderContent}
            </Col>
            <Col xs={3} className="docs-toc-minor"><DocsTocMinor docInFocus={this.state.docInFocus}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}